import { defineRule, configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import { required, email, digits } from "@vee-validate/rules";
import validation from "./lang/validation";

defineRule("required", required);
defineRule("email", email);
defineRule("digits", digits);

defineRule("phone", (value) => value.match(/^\+?\d*$/));

configure({
  generateMessage: localize({
    ...validation,
  }),
});

localize(document.documentElement.lang);
